// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'status',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'quantity',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'supplier',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'supplier_invoice_number',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'delivery_date',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'total_amount',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'total_due',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'remarks',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
